import { InputCapture } from '@canvas/input';

import { createHighlightsEffect } from './effects/highlights/create-highlights-effect';
import { EffectManager } from './effects/manager/effect-manager';
import { InputManager } from './inputs/manager/input-manager';
import { createMouseInput } from './inputs/mouse-input/create-mouse-input';
import { SelectionMachine } from './machine/selection-machine';

/**
 * Initializes the selections machine for all selections state, effects, etc.
 * in Databases.
 */
export function initializeSelectionsMachine() {
  const inputCapture = InputCapture.from(document.body);
  const machine = new SelectionMachine();
  const inputManager = new InputManager(machine, [
    (m) => createMouseInput(m, inputCapture),
  ]);
  const effectManager = new EffectManager(machine, [createHighlightsEffect]);

  inputManager.setup();
  effectManager.setup();

  return () => {
    effectManager.dispose();
    inputManager.dispose();
  };
}
